var global = window

var timerBuffer; // Un timer global, au besoin
global.timerBuffer = timerBuffer;

// ===================== Ouvre un popup avec la page ===============================
global.closePopup = function () {
    closeWindow();
}

global.loadPopup = function (content, width_var, height_var) {
    var settings = {
        id: 'centrallPopup',
        title: 'Popup',
        content,
        maxWidth: (width_var+20),		  // the minimum width, if -1 means no checking
        maxHeight: (height_var+50),		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        closable: true,
        showModal: true,
        width: (width_var+20)+'px',
        height: (height_var+50)+'px',
        checkBoundary: true,
        withinBrowserWindow: false,
    };
    $.window(settings);
}


// ================== Attend après l'aparition de l'élément défini et execute la commande voulue
global.waitFor = function (element, fonction) {
    if (document.getElementById(element)) {
        setTimeout(fonction, 100);
    } else {
        setTimeout("waitFor('" + element + "','" + fonction + "')", 100);
    }
}

global.openRedmineUrl = function (url) {
    window.open(url, '_blank');
}


global.popupWarning = function (message, titre, type) {
    swal({
        title: titre,
        text: message,
        html: true,
        type: (type) ? type : 'error'
    });
}